import * as React from "react"
import { MdArrowForward } from "react-icons/md"
import { Button } from "gatsby-interface"
import {
  cmsIntegration as cmsIntegrationText,
  ui as uiText,
} from "@modules/locales/default.js"
import { useTracker } from "@modules/analytics"
import { CmsVendor } from "@modules/graphql/types"

export type CmsOAuthFormProps = {
  siteId: string
  cmsVendor: CmsVendor
  cmsVendorName: string
  isProvisioning?: boolean
  onCancel: () => void
  onAuthorize: () => true | undefined
  origin?: `settings` | `createSite`
}

export function CmsOAuthForm({
  siteId,
  cmsVendor,
  cmsVendorName,
  isProvisioning,
  onCancel,
  onAuthorize,
  origin,
}: CmsOAuthFormProps) {
  const { trackButtonClicked } = useTracker()

  return (
    <div
      data-cy="cms-authorization-actions"
      css={{
        display: `flex`,
        alignItems: `center`,
        justifyContent: `space-between`,
      }}
    >
      <Button onClick={onCancel} tone="NEUTRAL" variant="SECONDARY">
        {uiText.actions.cancel}
      </Button>
      <Button
        onClick={() => {
          trackButtonClicked(`Authorize with ${cmsVendorName}`, {
            siteId: siteId,
            uiSource:
              origin === `settings`
                ? `Site settings: integrations`
                : `New Site Wizard: integrations`,
          })

          const isInterrupted = onAuthorize()
          if (isInterrupted) {
            return null
          }

          window.open(
            `${
              process.env.GATSBY_DASHBOARD_AUTHENTICATION_URL
            }/oauth/${cmsVendor.toLowerCase()}?siteId=${siteId}${
              isProvisioning ? `&provision=true` : ``
            }`,
            `_blank`,
            process.env.NODE_ENV === `production` ? `height=600,width=700` : ``
          )
        }}
        tone="BRAND"
        variant="PRIMARY"
        rightIcon={<MdArrowForward />}
      >
        {cmsIntegrationText.actions.authorize}
      </Button>
    </div>
  )
}
